import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

const TableDecorLink = ({ className, shortenCopy }) => {
  const copy = shortenCopy ? 'Shop Table Decor' : 'Shop Table Numbers & Decor';
  return (
    <ButtonV2
      component="a"
      variant="secondary"
      className={className}
      href="/shop/category/reception-centerpieces-table-decor"
      role="link"
      target="_blank"
    >
      {copy}
    </ButtonV2>
  );
};

TableDecorLink.propTypes = {
  className: PropTypes.string,
  shortenCopy: PropTypes.bool,
};

export default TableDecorLink;



// WEBPACK FOOTER //
// ./src/components/manage/common/TableDecorLink.jsx